<template>
  <BaseFollowupRuleDialog
    :name="name"
    :rule-holder-id="categoryId"
    :dialog.sync="_dialog"
    :show-details="showDetails"
    :query-rule-gql="queryRuleGql"
    :create-rule-gql="createRuleGql"
    :update-rule-gql="updateRuleGql"
    :get-query-variables="getQueryVariables"
    :is-rule-enabled="isRuleEnabled"
    :set-rule-enabled="setRuleEnabled"
    :default-rule-data="defaultRuleData"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BaseFollowupRuleDialog from './BaseFollowupRuleDialog'
import { LIST_CATEGORY_RULES, UPDATE_CATEGORY_RULE, CREATE_CATEGORY_RULE } from '@/backend/graphql/automationGQL'
import moment from 'moment-timezone'
import _ from 'lodash'
export default {
  name: 'CategoryFollowupRuleDialog',
  components: { BaseFollowupRuleDialog },
  props: {
    name: {
      type: String,
      default: ''
    },
    dialog: {
      type: Boolean,
      default: false
    },
    showDetails: {
      type: Boolean,
      default: true
    },
    categoryId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      queryRuleGql: LIST_CATEGORY_RULES,
      updateRuleGql: UPDATE_CATEGORY_RULE,
      createRuleGql: CREATE_CATEGORY_RULE,
      defaultRuleData: {
        name: '',
        categoryId: this.categoryId,
        ruleType: 'STAY_IN_CONTACT',
        enabled: true,
        repeated: true,
        applyToNew: false,
        frequency: 1,
        skipContactedWithin: 0,
        eventDate: moment().format('YYYY-MM-DD'),
        applyToBirthday: true,
        applyToAll: false,
        remindDays: -1,
        scheduleTime: '08:00 am',
        timeZone: moment.tz.guess(),
        ruleMessage: [{ body: '' }]
      }
    }
  },
  computed: {
    ...mapGetters({
      user: 'account/getUser',
      allRules: 'automation/getAllRules'
    }),
    _dialog: {
      get () {
        return this.dialog
      },
      set (val) {
        this.$emit('update:dialog', val)
      }
    }
  },
  methods: {
    ...mapActions({
      updateCategoryRuleByIndex: 'automation/updateCategoryRuleByIndex',
      createCategoryRule: 'automation/createCategoryRule'
    }),
    getQueryVariables () {
      return {
        limit: 50,
        offset: 0,
        orderBy: '-id,name',
        userIds: [_.get(this.user, 'id', 0)],
        categoryId: this.categoryId
      }
    },
    isRuleEnabled (index) {
      const category = _.get(this.allRules, `[${index}].category`, [])
      return category.filter((c) => Number(c.id) === Number(this.categoryId)).length > 0
    },
    setRuleEnabled (index) {
      this.updateCategoryRuleByIndex({ index, categoryId: this.categoryId })
    }
  }
}
</script>

<style scoped>

</style>
